module.exports = __webpack_public_path__ + "static/media/ceiling-tframe.601e60fb.jpg";